"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[181],{

/***/ 92679:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(14859);

__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;

var _createSvgIcon = _interopRequireDefault(__webpack_require__(68671));

var _jsxRuntime = __webpack_require__(52322);

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), 'Close');

exports.Z = _default;

/***/ }),

/***/ 13421:
/***/ (function(__unused_webpack_module, exports) {

/*!
 * cookie
 * Copyright(c) 2012-2014 Roman Shtylman
 * Copyright(c) 2015 Douglas Christopher Wilson
 * MIT Licensed
 */



/**
 * Module exports.
 * @public
 */

exports.parse = parse;
exports.serialize = serialize;

/**
 * Module variables.
 * @private
 */

var decode = decodeURIComponent;
var encode = encodeURIComponent;

/**
 * RegExp to match field-content in RFC 7230 sec 3.2
 *
 * field-content = field-vchar [ 1*( SP / HTAB ) field-vchar ]
 * field-vchar   = VCHAR / obs-text
 * obs-text      = %x80-FF
 */

var fieldContentRegExp = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;

/**
 * Parse a cookie header.
 *
 * Parse the given cookie header string into an object
 * The object has the various cookies as keys(names) => values
 *
 * @param {string} str
 * @param {object} [options]
 * @return {object}
 * @public
 */

function parse(str, options) {
  if (typeof str !== 'string') {
    throw new TypeError('argument str must be a string');
  }

  var obj = {}
  var opt = options || {};
  var pairs = str.split(';')
  var dec = opt.decode || decode;

  for (var i = 0; i < pairs.length; i++) {
    var pair = pairs[i];
    var index = pair.indexOf('=')

    // skip things that don't look like key=value
    if (index < 0) {
      continue;
    }

    var key = pair.substring(0, index).trim()

    // only assign once
    if (undefined == obj[key]) {
      var val = pair.substring(index + 1, pair.length).trim()

      // quoted values
      if (val[0] === '"') {
        val = val.slice(1, -1)
      }

      obj[key] = tryDecode(val, dec);
    }
  }

  return obj;
}

/**
 * Serialize data into a cookie header.
 *
 * Serialize the a name value pair into a cookie string suitable for
 * http headers. An optional options object specified cookie parameters.
 *
 * serialize('foo', 'bar', { httpOnly: true })
 *   => "foo=bar; httpOnly"
 *
 * @param {string} name
 * @param {string} val
 * @param {object} [options]
 * @return {string}
 * @public
 */

function serialize(name, val, options) {
  var opt = options || {};
  var enc = opt.encode || encode;

  if (typeof enc !== 'function') {
    throw new TypeError('option encode is invalid');
  }

  if (!fieldContentRegExp.test(name)) {
    throw new TypeError('argument name is invalid');
  }

  var value = enc(val);

  if (value && !fieldContentRegExp.test(value)) {
    throw new TypeError('argument val is invalid');
  }

  var str = name + '=' + value;

  if (null != opt.maxAge) {
    var maxAge = opt.maxAge - 0;

    if (isNaN(maxAge) || !isFinite(maxAge)) {
      throw new TypeError('option maxAge is invalid')
    }

    str += '; Max-Age=' + Math.floor(maxAge);
  }

  if (opt.domain) {
    if (!fieldContentRegExp.test(opt.domain)) {
      throw new TypeError('option domain is invalid');
    }

    str += '; Domain=' + opt.domain;
  }

  if (opt.path) {
    if (!fieldContentRegExp.test(opt.path)) {
      throw new TypeError('option path is invalid');
    }

    str += '; Path=' + opt.path;
  }

  if (opt.expires) {
    if (typeof opt.expires.toUTCString !== 'function') {
      throw new TypeError('option expires is invalid');
    }

    str += '; Expires=' + opt.expires.toUTCString();
  }

  if (opt.httpOnly) {
    str += '; HttpOnly';
  }

  if (opt.secure) {
    str += '; Secure';
  }

  if (opt.sameSite) {
    var sameSite = typeof opt.sameSite === 'string'
      ? opt.sameSite.toLowerCase() : opt.sameSite;

    switch (sameSite) {
      case true:
        str += '; SameSite=Strict';
        break;
      case 'lax':
        str += '; SameSite=Lax';
        break;
      case 'strict':
        str += '; SameSite=Strict';
        break;
      case 'none':
        str += '; SameSite=None';
        break;
      default:
        throw new TypeError('option sameSite is invalid');
    }
  }

  return str;
}

/**
 * Try decoding a string using a decoding function.
 *
 * @param {string} str
 * @param {function} decode
 * @private
 */

function tryDecode(str, decode) {
  try {
    return decode(str);
  } catch (e) {
    return str;
  }
}


/***/ }),

/***/ 18772:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var __webpack_unused_export__;


__webpack_unused_export__ = ({ value: true });

var parser = __webpack_require__(13421);
var universalCookie = __webpack_require__(75969);
var React = __webpack_require__(2784);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () {
            return e[k];
          }
        });
      }
    });
  }
  n['default'] = e;
  return Object.freeze(n);
}

var parser__namespace = /*#__PURE__*/_interopNamespace(parser);
var universalCookie__default = /*#__PURE__*/_interopDefaultLegacy(universalCookie);
var React__namespace = /*#__PURE__*/_interopNamespace(React);

var SET_COOKIE_HEADER = 'Set-Cookie';
var Cookie = /** @class */ (function () {
    function Cookie(ctxOrCookie) {
        this.isServer = typeof window === 'undefined';
        if (this.isServer) {
            if (typeof ctxOrCookie === 'string') {
                this.cookie = new universalCookie__default['default'](ctxOrCookie);
            }
            else if (ctxOrCookie && typeof ctxOrCookie.req !== 'undefined') {
                this.ctx = ctxOrCookie;
                this.cookie = new universalCookie__default['default'](this.ctx.req.headers.cookie);
            }
            else {
                this.cookie = new universalCookie__default['default']();
            }
        }
        else {
            var cookieString = void 0;
            if (typeof ctxOrCookie === 'string') {
                cookieString = ctxOrCookie;
            }
            this.cookie = new universalCookie__default['default'](cookieString);
        }
    }
    Cookie.fromApiRoute = function (req, res) {
        return new Cookie({ req: req, res: res });
    };
    /**
     * Returns true if the cookie value exists.
     *
     * @param name The name of the cookie.
     * @returns True if it exists, false otherwise.
     */
    Cookie.prototype.has = function (name) {
        return typeof this.get(name) !== 'undefined';
    };
    /**
     * Get value of cookie.
     *
     * @param name The name of the cookie.
     * @param options `CookieGetOptions` used in `universal-cookie`.
     * @returns The cookie value or null if not found.
     */
    Cookie.prototype.get = function (name, options) {
        return this.cookie.get(name, options);
    };
    /**
     * Get all cookies.
     *
     * @param options `CookieGetOptions` used in `universal-cookie`.
     */
    /* eslint-disable @typescript-eslint/no-explicit-any */
    Cookie.prototype.getAll = function (options) {
        return this.cookie.getAll(options);
    };
    /* eslint-enable @typescript-eslint/no-explicit-any */
    /**
     * Set a cookie.
     *
     * @param name The name of the cookie.
     * @param value The value of the cookie.
     * @param options `CookieSetOptions` used in `universal-cookie`.
     */
    /* eslint-disable @typescript-eslint/no-explicit-any */
    Cookie.prototype.set = function (name, value, options) {
        // if the expires is number, then convert to Date.
        if (options && typeof options.expires === 'number') {
            options.expires = new Date(new Date() * 1 + options.expires * 864e+5);
        }
        if (this.isServer && this.ctx) {
            var cookies = this.ctx.res.getHeader(SET_COOKIE_HEADER) || [];
            this.cookie.set(name, value, options);
            cookies.push(parser__namespace.serialize(name, value, options));
            this.ctx.res.setHeader(SET_COOKIE_HEADER, cookies);
        }
        else {
            this.cookie.set(name, value, options);
        }
    };
    /* eslint-enable @typescript-eslint/no-explicit-any */
    /**
     * Remove a cookie by name.
     *
     * @param name The name of the cookie.
     * @param options `CookieSetOptions` used in `universal-cookie`.
     */
    Cookie.prototype.remove = function (name, options) {
        if (!this.has(name)) {
            return;
        }
        var opt = Object.assign({
            expires: new Date(),
            path: '/',
        }, options || {});
        if (this.isServer && this.ctx) {
            this.ctx.res.setHeader(SET_COOKIE_HEADER, parser__namespace.serialize(name, '', opt));
        }
        else {
            this.cookie.remove(name, opt);
        }
    };
    return Cookie;
}());

function useCookie(ctxOrCookie) {
    return new Cookie(ctxOrCookie);
}

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function withCookie(ComposedComponent) {
    var _this = this;
    var name = ComposedComponent.displayName || ComposedComponent.name;
    var WithCookieWrapper = /** @class */ (function (_super) {
        __extends(WithCookieWrapper, _super);
        function WithCookieWrapper() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        WithCookieWrapper.prototype.render = function () {
            var cookie = new Cookie();
            return (React__namespace.createElement(ComposedComponent, __assign({ cookie: cookie }, this.props)));
        };
        WithCookieWrapper.displayName = "withCookie(" + name + ")";
        return WithCookieWrapper;
    }(React__namespace.Component));
    if (ComposedComponent.getInitialProps) {
        WithCookieWrapper.getInitialProps = function (ctx) { return __awaiter(_this, void 0, void 0, function () {
            var initialProps;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        ctx.cookie = new Cookie(ctx);
                        return [4 /*yield*/, ComposedComponent.getInitialProps(ctx)];
                    case 1:
                        initialProps = _a.sent();
                        if (ctx.cookie) {
                            delete ctx.cookie;
                        }
                        return [2 /*return*/, initialProps];
                }
            });
        }); };
    }
    return WithCookieWrapper;
}

__webpack_unused_export__ = Cookie;
exports.By = useCookie;
__webpack_unused_export__ = withCookie;


/***/ }),

/***/ 58181:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ Agreement; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ./src/hooks/use-channel-config.ts
var use_channel_config = __webpack_require__(87117);
// EXTERNAL MODULE: ./src/hooks/use-default-entity.ts
var use_default_entity = __webpack_require__(86609);
// EXTERNAL MODULE: ./src/hooks/use-text-overrides.ts
var use_text_overrides = __webpack_require__(84055);
;// CONCATENATED MODULE: ./src/lib/constants.ts
/* provided dependency */ var process = __webpack_require__(34406);
var API_ENDPOINT_COOKIE = "kenai-induction-endpoint";
var INVITES_TOKEN_COOKIE = "kenai-induction-token";
var HEADER_HEIGHT = 77; // px
var LOCALE_COOKIE = "NEXT_LOCALE";
var LOGGING_COOKIE = "kenai-induction-logging";
var AGREEMENT_COOKIE = "kenai-induction-agreement";
var DEV_MODE =  false || process.env.VERCEL_ENV === "preview";

// EXTERNAL MODULE: ./src/slices/stepper.ts
var stepper = __webpack_require__(76739);
// EXTERNAL MODULE: ./src/store/index.ts + 5 modules
var store = __webpack_require__(13793);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(26297);
// EXTERNAL MODULE: ../../node_modules/@mui/material/SvgIcon/SvgIcon.js + 1 modules
var SvgIcon = __webpack_require__(82175);
;// CONCATENATED MODULE: ../../packages/kenai-core/src/icons/external-link.tsx




function ExternalLink(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SvgIcon/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 512",
        width: "1em",
        height: "1em"
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M488 0h-135.3c-13.25 0-25.09 7.906-30.19 20.16c-5.062 12.28-2.281 26.25 7.094 35.63l40.69 40.69L177.4 289.4c-12.5 12.5-12.5 32.75 0 45.25C183.6 340.9 191.8 344 200 344s16.38-3.125 22.62-9.375l192.9-192.9l40.69 40.69C462.5 188.7 470.8 192 479.3 192c4.219 0 8.469-.8125 12.56-2.5C504.1 184.4 512 172.6 512 159.3V24C512 10.75 501.3 0 488 0zM392 320c-13.25 0-24 10.75-24 24v112c0 4.406-3.594 8-8 8h-304c-4.406 0-8-3.594-8-8v-304c0-4.406 3.594-8 8-8h112C181.3 144 192 133.3 192 120S181.3 96 168 96h-112C25.13 96 0 121.1 0 152v304C0 486.9 25.13 512 56 512h304c30.88 0 56-25.12 56-56v-112C416 330.8 405.3 320 392 320z"
        })
    }));
}

// EXTERNAL MODULE: ../../packages/kenai-core/src/components/s3image/s3image.tsx
var s3image = __webpack_require__(59811);
// EXTERNAL MODULE: ../../packages/kenai-core/src/hooks/use-media-query.ts
var use_media_query = __webpack_require__(91363);
// EXTERNAL MODULE: ../../node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(67107);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(47842);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(66383);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(31461);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(6277);
// EXTERNAL MODULE: ../../node_modules/@mui/base/composeClasses/composeClasses.js
var composeClasses = __webpack_require__(77597);
// EXTERNAL MODULE: ../../node_modules/@mui/system/esm/style.js
var style = __webpack_require__(2818);
// EXTERNAL MODULE: ../../node_modules/@mui/system/esm/colorManipulator.js
var colorManipulator = __webpack_require__(47591);
// EXTERNAL MODULE: ../../node_modules/@mui/material/utils/capitalize.js + 1 modules
var capitalize = __webpack_require__(8036);
// EXTERNAL MODULE: ../../node_modules/@mui/material/styles/styled.js + 2 modules
var styled = __webpack_require__(67393);
// EXTERNAL MODULE: ../../node_modules/@mui/material/styles/useThemeProps.js + 1 modules
var useThemeProps = __webpack_require__(74017);
// EXTERNAL MODULE: ../../node_modules/@mui/material/utils/useIsFocusVisible.js + 1 modules
var useIsFocusVisible = __webpack_require__(25148);
// EXTERNAL MODULE: ../../node_modules/@mui/material/utils/useForkRef.js + 1 modules
var useForkRef = __webpack_require__(33864);
// EXTERNAL MODULE: ../../node_modules/@mui/base/generateUtilityClass/generateUtilityClass.js
var generateUtilityClass = __webpack_require__(72606);
// EXTERNAL MODULE: ../../node_modules/@mui/base/generateUtilityClasses/generateUtilityClasses.js
var generateUtilityClasses = __webpack_require__(98922);
;// CONCATENATED MODULE: ../../node_modules/@mui/material/Link/linkClasses.js

function getLinkUtilityClass(slot) {
    return (0,generateUtilityClass/* default */.Z)("MuiLink", slot);
}
var linkClasses = (0,generateUtilityClasses/* default */.Z)("MuiLink", [
    "root",
    "underlineNone",
    "underlineHover",
    "underlineAlways",
    "button",
    "focusVisible"
]);
/* harmony default export */ var Link_linkClasses = (linkClasses);

;// CONCATENATED MODULE: ../../node_modules/@mui/material/Link/Link.js




var _excluded = [
    "className",
    "color",
    "component",
    "onBlur",
    "onFocus",
    "TypographyClasses",
    "underline",
    "variant"
];














var colorTransformations = {
    primary: "primary.main",
    textPrimary: "text.primary",
    secondary: "secondary.main",
    textSecondary: "text.secondary",
    error: "error.main"
};
var transformDeprecatedColors = function(color) {
    return colorTransformations[color] || color;
};
var useUtilityClasses = function(ownerState) {
    var classes = ownerState.classes, component = ownerState.component, focusVisible = ownerState.focusVisible, underline = ownerState.underline;
    var slots = {
        root: [
            "root",
            "underline".concat((0,capitalize/* default */.Z)(underline)),
            component === "button" && "button",
            focusVisible && "focusVisible"
        ]
    };
    return (0,composeClasses/* default */.Z)(slots, getLinkUtilityClass, classes);
};
var LinkRoot = (0,styled/* default */.ZP)(Typography/* default */.Z, {
    name: "MuiLink",
    slot: "Root",
    overridesResolver: function(props, styles) {
        var ownerState = props.ownerState;
        return [
            styles.root,
            styles["underline".concat((0,capitalize/* default */.Z)(ownerState.underline))],
            ownerState.component === "button" && styles.button
        ];
    }
})(function(param) {
    var theme = param.theme, ownerState = param.ownerState;
    var color = (0,style/* getPath */.D)(theme, "palette.".concat(transformDeprecatedColors(ownerState.color))) || ownerState.color;
    return (0,esm_extends/* default */.Z)({}, ownerState.underline === "none" && {
        textDecoration: "none"
    }, ownerState.underline === "hover" && {
        textDecoration: "none",
        "&:hover": {
            textDecoration: "underline"
        }
    }, ownerState.underline === "always" && {
        textDecoration: "underline",
        textDecorationColor: color !== "inherit" ? (0,colorManipulator/* alpha */.Fq)(color, 0.4) : undefined,
        "&:hover": {
            textDecorationColor: "inherit"
        }
    }, ownerState.component === "button" && (0,_define_property/* default */.Z)({
        position: "relative",
        WebkitTapHighlightColor: "transparent",
        backgroundColor: "transparent",
        // Reset default value
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0,
        border: 0,
        margin: 0,
        // Remove the margin in Safari
        borderRadius: 0,
        padding: 0,
        // Remove the padding in Firefox
        cursor: "pointer",
        userSelect: "none",
        verticalAlign: "middle",
        MozAppearance: "none",
        // Reset
        WebkitAppearance: "none",
        // Reset
        "&::-moz-focus-inner": {
            borderStyle: "none" // Remove Firefox dotted outline.
        }
    }, "&.".concat(Link_linkClasses.focusVisible), {
        outline: "auto"
    }));
});
var Link = /*#__PURE__*/ react.forwardRef(function Link(inProps, ref) {
    var props = (0,useThemeProps/* default */.Z)({
        props: inProps,
        name: "MuiLink"
    });
    var className = props.className, _color = props.color, color = _color === void 0 ? "primary" : _color, _component = props.component, component = _component === void 0 ? "a" : _component, onBlur = props.onBlur, onFocus = props.onFocus, TypographyClasses = props.TypographyClasses, _underline = props.underline, underline = _underline === void 0 ? "always" : _underline, _variant = props.variant, variant = _variant === void 0 ? "inherit" : _variant, other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded);
    var _$ref = (0,useIsFocusVisible/* default */.Z)(), isFocusVisibleRef = _$ref.isFocusVisibleRef, handleBlurVisible = _$ref.onBlur, handleFocusVisible = _$ref.onFocus, focusVisibleRef = _$ref.ref;
    var _$ref1 = (0,_sliced_to_array/* default */.Z)(react.useState(false), 2), focusVisible = _$ref1[0], setFocusVisible = _$ref1[1];
    var handlerRef = (0,useForkRef/* default */.Z)(ref, focusVisibleRef);
    var handleBlur = function(event) {
        handleBlurVisible(event);
        if (isFocusVisibleRef.current === false) {
            setFocusVisible(false);
        }
        if (onBlur) {
            onBlur(event);
        }
    };
    var handleFocus = function(event) {
        handleFocusVisible(event);
        if (isFocusVisibleRef.current === true) {
            setFocusVisible(true);
        }
        if (onFocus) {
            onFocus(event);
        }
    };
    var ownerState = (0,esm_extends/* default */.Z)({}, props, {
        color: color,
        component: component,
        focusVisible: focusVisible,
        underline: underline,
        variant: variant
    });
    var classes = useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkRoot, (0,esm_extends/* default */.Z)({
        className: (0,clsx_m/* default */.Z)(classes.root, className),
        classes: TypographyClasses,
        color: color,
        component: component,
        onBlur: handleBlur,
        onFocus: handleFocus,
        ref: handlerRef,
        ownerState: ownerState,
        variant: variant
    }, other));
});
 false ? 0 : void 0;
/* harmony default export */ var Link_Link = (Link);

// EXTERNAL MODULE: ../../node_modules/@mui/material/FormControlLabel/FormControlLabel.js + 1 modules
var FormControlLabel = __webpack_require__(79511);
// EXTERNAL MODULE: ../../node_modules/@mui/material/Checkbox/Checkbox.js + 4 modules
var Checkbox = __webpack_require__(79728);
// EXTERNAL MODULE: ../../node_modules/@mui/material/Button/Button.js + 3 modules
var Button = __webpack_require__(15328);
// EXTERNAL MODULE: ../../node_modules/@mui/material/Dialog/Dialog.js + 1 modules
var Dialog = __webpack_require__(50817);
// EXTERNAL MODULE: ../../node_modules/@mui/material/DialogTitle/DialogTitle.js
var DialogTitle = __webpack_require__(73217);
// EXTERNAL MODULE: ../../node_modules/@mui/material/IconButton/IconButton.js + 1 modules
var IconButton = __webpack_require__(46105);
// EXTERNAL MODULE: ../../node_modules/@mui/material/DialogContent/DialogContent.js + 1 modules
var DialogContent = __webpack_require__(3437);
// EXTERNAL MODULE: ../../node_modules/next-cookie/dist/next-cookie.js
var next_cookie = __webpack_require__(18772);
// EXTERNAL MODULE: ../../node_modules/@mui/icons-material/Close.js
var Close = __webpack_require__(92679);
;// CONCATENATED MODULE: ../../packages/kenai-core/src/components/agreement-reader/agreement-reader.tsx










var AgreementLayout = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "agreement-layout h-full grid text-left py-10 md:py-20 place-content-center place-items-center",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "container",
            children: children
        })
    });
};
var AgreementReader = function(_param) {
    var _padding = _param.padding, padding = _padding === void 0 ? true : _padding, slotProps = _param.slotProps, props = (0,_object_without_properties/* default */.Z)(_param, [
        "padding",
        "slotProps"
    ]);
    var ref = (0,react.useState)(false), agreementConfirmed = ref[0], setAgreementConfirmed = ref[1];
    var cookie = (0,next_cookie/* useCookie */.By)();
    var agreementCookie = cookie.get(props.cookieName);
    var fullScreen = (0,use_media_query/* useMediaQuery */.a)(function(theme) {
        return theme.breakpoints.down("sm");
    });
    var ref1 = (0,react.useState)(false), visible = ref1[0], setVisible = ref1[1];
    var ref2 = (0,react.useState)(false), acceptContinue = ref2[0], setAcceptContinue = ref2[1];
    var ref3 = (0,react.useState)(props.mandatoryRead || false), mandatoryRead = ref3[0], setMandatoryRead = ref3[1];
    (0,react.useEffect)(function() {
        setMandatoryRead(props.mandatoryRead || false);
    }, [
        props.mandatoryRead
    ]);
    (0,react.useEffect)(function() {
        var agreementConfirmed = [
            "TEST-MODE",
            props.identifier
        ].includes(agreementCookie || "");
        setAgreementConfirmed(agreementConfirmed);
    }, [
        props.identifier,
        agreementCookie
    ]);
    (0,react.useEffect)(function() {
        if (!agreementCookie && mandatoryRead) {
            setMandatoryRead(true);
        } else {
            setAgreementConfirmed(true);
        }
    }, [
        agreementCookie,
        mandatoryRead
    ]);
    var handleContinue = function() {
        if (mandatoryRead) {
            if (agreementConfirmed) {
                var ref;
                (ref = props.onAgreementContinue) === null || ref === void 0 ? void 0 : ref.call(props);
            } else {
                setAcceptContinue(true);
                setVisible(true);
            }
        } else {
            var ref1;
            (ref1 = props.onAgreementContinue) === null || ref1 === void 0 ? void 0 : ref1.call(props);
        }
    };
    var handleAcceptAgreement = function() {
        cookie.set(props.cookieName, props.identifier);
        setAgreementConfirmed(true);
        setMandatoryRead(false);
        setVisible(false);
        if (acceptContinue) {
            var ref;
            (ref = props.onAgreementContinue) === null || ref === void 0 ? void 0 : ref.call(props);
        }
    };
    var AgreementText = /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
        sx: {
            lineHeight: "42px"
        },
        variant: "body1",
        onClick: function(e) {
            e.stopPropagation();
            e.preventDefault();
            setVisible(true);
        },
        children: [
            "I have read, understood and accepted the",
            " ",
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Link_Link, {
                tabIndex: 1,
                role: "button",
                onClick: function() {
                    return setVisible(true);
                },
                onKeyDown: function(e) {
                    return e.key === "Enter" || e.code === "Space" ? setVisible(true) : null;
                },
                style: {
                    lineHeight: "inherit"
                },
                children: [
                    props.agreementLinkText || "agreement",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        variant: "body1",
                        component: "span",
                        noWrap: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ExternalLink, {
                            sx: {
                                fontSize: 14
                            }
                        })
                    })
                ]
            })
        ]
    });
    var handleDenyAgreement = (0,react.useCallback)(function() {
        cookie.remove(props.cookieName);
        setAgreementConfirmed(false);
        if (props.mandatoryRead) {
            setMandatoryRead(true);
        }
    }, [
        props.mandatoryRead,
        agreementConfirmed
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            props.companyLogo && /*#__PURE__*/ (0,jsx_runtime.jsx)(s3image/* S3Image */.P, {
                src: props.companyLogo,
                width: 200,
                height: 100,
                alt: props.companyName,
                className: "object-contain object-left"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "mb-2 md:mb-4 mt-4",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        variant: "h4",
                        component: "h1",
                        children: props.headingText
                    }),
                    props.description && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        variant: "subtitle1",
                        children: props.description
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mt-4",
                        children: !mandatoryRead || agreementConfirmed ? /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControlLabel/* default */.Z, {
                            control: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                                inputProps: {
                                    "data-cy": "agreement-checkbox"
                                },
                                onClick: handleDenyAgreement,
                                checked: agreementConfirmed,
                                disabled: props.disabled
                            }),
                            label: AgreementText
                        }) : AgreementText
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "action-container pt-8",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                    variant: "contained",
                    onClick: handleContinue,
                    tabIndex: 2
                }, slotProps === null || slotProps === void 0 ? void 0 : slotProps.continueButton), {
                    children: "Continue"
                }))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Dialog/* default */.Z, {
                open: visible,
                fullScreen: fullScreen,
                maxWidth: "lg",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(DialogTitle/* default */.Z, {
                        children: [
                            props.dialogTitle || "Agreement",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                "aria-label": "close",
                                onClick: function() {
                                    return setVisible(false);
                                },
                                sx: {
                                    position: "absolute",
                                    right: 8,
                                    top: 8,
                                    color: function(theme) {
                                        return theme.palette.grey[500];
                                    }
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Close/* default */.Z, {})
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(DialogContent/* default */.Z, {
                        dividers: true,
                        sx: !padding ? {
                            padding: 0
                        } : undefined,
                        children: [
                            props.children,
                            padding && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mb-20",
                                "aria-hidden": true
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "absolute bottom-0 right-0 z-10 pr-8 pb-5",
                                children: agreementConfirmed ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                    size: "large",
                                    variant: "contained",
                                    onClick: handleContinue
                                }, slotProps === null || slotProps === void 0 ? void 0 : slotProps.continueButton), {
                                    children: "Continue"
                                })) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                    size: "large",
                                    variant: "contained",
                                    onClick: handleAcceptAgreement
                                }, slotProps === null || slotProps === void 0 ? void 0 : slotProps.continueButton), {
                                    children: "Accept"
                                }))
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ../../node_modules/next/dynamic.js
var dynamic = __webpack_require__(25237);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
;// CONCATENATED MODULE: ./src/components/agreement/agreement.tsx









var PDFReader = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(578), __webpack_require__.e(859), __webpack_require__.e(993), __webpack_require__.e(633)]).then(__webpack_require__.bind(__webpack_require__, 31));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(31)
            ];
        }
    }
});
function Agreement() {
    var channelConfig = (0,use_channel_config/* useChannelConfig */.M)();
    var defaultEntity = (0,use_default_entity/* useDefaultEntity */.t)();
    var textOverrides = (0,use_text_overrides/* useTextOverrides */.u)();
    var dispatch = (0,store/* useDispatch */.I0)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "h-screen",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AgreementLayout, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AgreementReader, {
                padding: false,
                dialogTitle: "Employee Agreement",
                headingText: textOverrides.agreementTitle || "Welcome to the Employee Induction",
                description: textOverrides.agreementSubTitle,
                identifier: channelConfig._agreementIdentifier || Date.now().toString(),
                cookieName: AGREEMENT_COOKIE,
                companyName: (defaultEntity === null || defaultEntity === void 0 ? void 0 : defaultEntity.companyName) || "",
                companyLogo: channelConfig.logo,
                onAgreementContinue: function() {
                    dispatch(stepper/* stepper.nextStep */.Sc.nextStep());
                },
                mandatoryRead: channelConfig.mandatoryAgreementRead,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PDFReader, {
                    url: channelConfig.agreementLink
                })
            })
        })
    });
}

;// CONCATENATED MODULE: ./src/components/agreement/index.ts



/***/ }),

/***/ 75969:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ es6; }
});

// EXTERNAL MODULE: ../../node_modules/cookie/index.js
var cookie = __webpack_require__(13421);
;// CONCATENATED MODULE: ../../node_modules/universal-cookie/es6/utils.js

function hasDocumentCookie() {
    // Can we get/set cookies on document.cookie?
    return typeof document === 'object' && typeof document.cookie === 'string';
}
function cleanCookies() {
    document.cookie.split(';').forEach(function (c) {
        document.cookie = c
            .replace(/^ +/, '')
            .replace(/=.*/, '=;expires=' + new Date().toUTCString() + ';path=/');
    });
}
function parseCookies(cookies, options) {
    if (typeof cookies === 'string') {
        return cookie.parse(cookies, options);
    }
    else if (typeof cookies === 'object' && cookies !== null) {
        return cookies;
    }
    else {
        return {};
    }
}
function isParsingCookie(value, doNotParse) {
    if (typeof doNotParse === 'undefined') {
        // We guess if the cookie start with { or [, it has been serialized
        doNotParse =
            !value || (value[0] !== '{' && value[0] !== '[' && value[0] !== '"');
    }
    return !doNotParse;
}
function readCookie(value, options) {
    if (options === void 0) { options = {}; }
    var cleanValue = cleanupCookieValue(value);
    if (isParsingCookie(cleanValue, options.doNotParse)) {
        try {
            return JSON.parse(cleanValue);
        }
        catch (e) {
            // At least we tried
        }
    }
    // Ignore clean value if we failed the deserialization
    // It is not relevant anymore to trim those values
    return value;
}
function cleanupCookieValue(value) {
    // express prepend j: before serializing a cookie
    if (value && value[0] === 'j' && value[1] === ':') {
        return value.substr(2);
    }
    return value;
}

;// CONCATENATED MODULE: ../../node_modules/universal-cookie/es6/Cookies.js
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};


var Cookies = /** @class */ (function () {
    function Cookies(cookies, options) {
        var _this = this;
        this.changeListeners = [];
        this.HAS_DOCUMENT_COOKIE = false;
        this.cookies = parseCookies(cookies, options);
        new Promise(function () {
            _this.HAS_DOCUMENT_COOKIE = hasDocumentCookie();
        }).catch(function () { });
    }
    Cookies.prototype._updateBrowserValues = function (parseOptions) {
        if (!this.HAS_DOCUMENT_COOKIE) {
            return;
        }
        this.cookies = cookie.parse(document.cookie, parseOptions);
    };
    Cookies.prototype._emitChange = function (params) {
        for (var i = 0; i < this.changeListeners.length; ++i) {
            this.changeListeners[i](params);
        }
    };
    Cookies.prototype.get = function (name, options, parseOptions) {
        if (options === void 0) { options = {}; }
        this._updateBrowserValues(parseOptions);
        return readCookie(this.cookies[name], options);
    };
    Cookies.prototype.getAll = function (options, parseOptions) {
        if (options === void 0) { options = {}; }
        this._updateBrowserValues(parseOptions);
        var result = {};
        for (var name_1 in this.cookies) {
            result[name_1] = readCookie(this.cookies[name_1], options);
        }
        return result;
    };
    Cookies.prototype.set = function (name, value, options) {
        var _a;
        if (typeof value === 'object') {
            value = JSON.stringify(value);
        }
        this.cookies = __assign(__assign({}, this.cookies), (_a = {}, _a[name] = value, _a));
        if (this.HAS_DOCUMENT_COOKIE) {
            document.cookie = cookie.serialize(name, value, options);
        }
        this._emitChange({ name: name, value: value, options: options });
    };
    Cookies.prototype.remove = function (name, options) {
        var finalOptions = (options = __assign(__assign({}, options), { expires: new Date(1970, 1, 1, 0, 0, 1), maxAge: 0 }));
        this.cookies = __assign({}, this.cookies);
        delete this.cookies[name];
        if (this.HAS_DOCUMENT_COOKIE) {
            document.cookie = cookie.serialize(name, '', finalOptions);
        }
        this._emitChange({ name: name, value: undefined, options: options });
    };
    Cookies.prototype.addChangeListener = function (callback) {
        this.changeListeners.push(callback);
    };
    Cookies.prototype.removeChangeListener = function (callback) {
        var idx = this.changeListeners.indexOf(callback);
        if (idx >= 0) {
            this.changeListeners.splice(idx, 1);
        }
    };
    return Cookies;
}());
/* harmony default export */ var es6_Cookies = (Cookies);

;// CONCATENATED MODULE: ../../node_modules/universal-cookie/es6/index.js

/* harmony default export */ var es6 = (es6_Cookies);


/***/ })

}]);